<template>
  <div class="customer-card-template" >
    <div class="customer-card">
      <div class="customer-card-title">
        <span class="title" :style="{ 'background-image': `url(${bg})`}">{{ title }}</span>
        <el-tooltip class="item" effect="dark"  placement="top-start" popper-class="template-card-tips">
          <!-- :content="tips" -->
          <div slot="content">
            <span v-html="tips"></span>
          </div>
          <span class="tips"></span>
        </el-tooltip>
      </div>
      <div class="slot-context">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    bg: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.customer-card-template {
  // width: 1244px;
  // height: 349px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  box-shadow:  0 2px 18px 0 rgba(144,151,171,0.22);

  margin-top: 16px;

  .customer-card {
    margin: 24px;
    .customer-card-title {
      padding-bottom: 16px;
      .title {
        color: #23252B;
        font-size: 16px;
        font-family: "PingFang SC", "Microsoft YaHei", "黑体",
            "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
        font-weight: 600;

        background-repeat: no-repeat;
        background-size: 24px;
        background-position: left 0% bottom 65%;
        padding-left: 28px;
      }
      .tips {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: text-top;
        background-image: url("~@/assets/front/lui-icon-help-solid.png");
        background-size: cover;
        cursor: pointer;
      }
    }
    .slot-context {
      display: grid;
      justify-content: center;
    }
  }
}
.customer-board-wrap {
  display: grid;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss">
.template-card-tips {
  a {
    color: #3C6EF0;
  }
}
</style>
